import { render, staticRenderFns } from "./SingleInfo.vue?vue&type=template&id=2f2be7ed&scoped=true&"
import script from "./SingleInfo.vue?vue&type=script&lang=js&"
export * from "./SingleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2be7ed",
  null
  
)

export default component.exports